const React = require('react');
const noop = require('mn-utils/noop');
const delay = require('mn-utils/delay');
const toLower = require('mn-utils/toLower');
const trim = require('mn-utils/trim');
const withReDelay = require('mn-utils/withReDelay');
const isEmail = require('mn-utils/isEmail');
const isInvalidStringLength = require('mn-utils/isInvalidStringLength');
const changeProviderProvider = require('mn-utils/changeProviderProvider');
const onEnterProvider = require('mn-utils/onEnterProvider');
const IconButton = require('@material-ui/core/IconButton').default;
const Visibility = require('@material-ui/icons/Visibility').default;
const VisibilityOff = require('@material-ui/icons/VisibilityOff').default;
const {
  LINK_SIGN_IN,
  LINK_START_VERIFICATION,
} = require('../../../../constants/links');
const validatePassword = require('../../../../utils/validatePassword');
const withState = require('../../../../utils/withState');
const {
  apiAuthCheckEmail,
} = require('../../../../api/_auth');
const {
  pushLocation,
  Link,
} = require('../../../../router');
const {
  account$,
} = require('../../../../emitters/account');
const Loading = require('../../../dumb/Loading');
const TextFieldI = require('../../../dumb/TextField/I');
const CheckboxD = require('../../../dumb/Checkbox/D');
const ButtonAccept = require('../../../dumb/Button/Accept');
const {
  resendVerificationCode,
} = require('./emitters/resendVerification');
const Base = require('./components/Base');


module.exports = withState((setState, self, onMount) => {
  const changeProvider = changeProviderProvider(setState);
  const handleChangePassword = changeProvider('password');
  let _passwordNode;
  let _cancelAccountCheckEmail = noop;

  const handleValidateEmail = withReDelay((email) => {
    _cancelAccountCheckEmail = apiAuthCheckEmail({
      email: toLower(email),
    }).finally((error, v) => {
      setState({
        alreadyUsed: error ? true : v && v.invalid || false,
        loadingCheckEmail: false,
      });
    }).cancel;
  }, 1000);

  function handlePasswordRef(node) {
    node && (_passwordNode = node);
  }

  function handleEmailEnter() {
    _passwordNode && _passwordNode.focus();
  }

  function handleChangeEmailWithValidate(e) {
    const email = e.target.value;
    const _email = trim(email);
    const validEmail = isEmail(_email);
    _cancelAccountCheckEmail();
    handleValidateEmail.cancel();
    setState({
      email,
      alreadyUsed: false,
      loadingCheckEmail: validEmail,
    });
    validEmail && handleValidateEmail(_email);
  }

  onMount(() => () => {
    handleValidateEmail.cancel();
    _cancelAccountCheckEmail();
  });

  return (state) => {
    const {
      loadingCheckEmail,
    } = state;
    const accept = state.accept || false;
    const clicked = state.clicked || false;
    const alreadyUsed = state.alreadyUsed || false;
    const password = state.password || '';
    const email = state.email || '';
    const _email = trim(email);
    const showPassword = state.showPassword || 0;
    const invalidPasswordChars = !validatePassword(password);
    const invalidPasswordLength = isInvalidStringLength(password, 8);
    const invalidPasswordWeak = !validatePassword.week(password);
    const invalidAccept = !accept;

    const _invalidEmail = !isEmail(_email);
    const invalidEmail = clicked && _invalidEmail
      || !!email && alreadyUsed || false;
    const invalidPassword = invalidPasswordChars
      || invalidPasswordLength
      || invalidPasswordWeak;
    const disabled = invalidPassword
      || _invalidEmail
      || alreadyUsed
      || invalidAccept
      || loadingCheckEmail;

    const VisibilityIcon = showPassword
      ? VisibilityOff
      : Visibility;


    function handleSubmit() {
      _passwordNode && _passwordNode.blur();
      const email = toLower(_email);
      if (disabled) {
        setState({
          clicked: true,
        });
        return;
      }
      account$.signUpMerchant({
        email,
        password: trim(password),
        disclaimer_accepted: accept,
      }).then((response) => {
        pushLocation({
          path: LINK_START_VERIFICATION + '/' + encodeURIComponent(email) + '/',
        });
        delay(resendVerificationCode, 100, [response.confirm_timeout]);
      });
    }

    return (
      <Base
        title="Create your account"
        description="Join our Retailer community"
        content={(<>
          <div className="rlv">
            <TextFieldI
              className="mb30"
              label="Email"
              value={email}
              error={invalidEmail}
              onChange={handleChangeEmailWithValidate}
              onKeyPress={onEnterProvider(handleEmailEnter)}
              helperText={
                alreadyUsed
                  ? 'This login is already used'
                  : 'This email is not valid'
              }
            />
            {
              loadingCheckEmail ? (
                <div className="abs srb sq45 z1">
                  <Loading/>
                </div>
              ) : null
            }
          </div>
          <TextFieldI
            className="mt18"
            type={showPassword ? 'text' : 'password'}
            label="Password"
            value={password}
            error={clicked && invalidPassword}
            helperText={
              invalidPasswordChars
                ? 'Password must contain Latin letters, numbers and symbols'
                : (
                  invalidPasswordLength
                    ? 'Password must contain at least 8 characters'
                    : 'Password too weak'
                )
            }
            onChange={handleChangePassword}
            onKeyPress={onEnterProvider(handleSubmit)}
            inputRef={handlePasswordRef}
            InputProps={{
              endAdornment: (
                <IconButton
                  className="rlv sl8 mv-5*2"
                  onClick={() => {
                    setState({
                      showPassword: !showPassword,
                    });
                  }}
                >
                  <VisibilityIcon className="c0C"/>
                </IconButton>
              ),
            }}
          />
        </>)}
        beforeFooter={(
          <div className="hmin84 layoutRow fhaS fvaC">
            <CheckboxD
              label={(<>
                by checking this button, I accept <a
                  className="c5B47FF dn o70:h"
                  href="https://lunu.io/terms"
                  target="_blank"
                  rel="noreferrer"
                >all Lunu Terms and conditions</a> and <a
                  className="c5B47FF dn o70:h"
                  href="https://lunu.io/privacy"
                  target="_blank"
                  rel="noreferrer"
                >Privacy policy</a>
              </>)}
              checked={accept}
              onChange={(accept) => {
                setState({
                  accept,
                });
              }}
              error={invalidAccept && clicked}
            />
          </div>
        )}
        control={(
          <ButtonAccept
            disabled={disabled && clicked}
            onClick={handleSubmit}
          >Sign Up</ButtonAccept>
        )}
        additional={(<>
          <div className="f12 fw3 lh lts0em">
            Already have an account?
          </div>
          <div className="pl12 rlv st-2 wmin72">
            <Link
              xhref={LINK_SIGN_IN}
              href="/sign-in"
              className="c5B47FF olN tdU dn f16 fw3 o70:h"
            >Sign in</Link>
          </div>
        </>)}
      />
    );
  };
});
